import { shallowEqual, useSelector } from 'react-redux';
import { getOpenCaseType } from '../ducks';

export const useGetOpenCaseType = () => ({
  openCaseType: useSelector(getOpenCaseType, shallowEqual),
});
